/**********************
 * Content events Conversations
 *********************/
import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import { Button, Col, Row } from "reactstrap"
import { Table as AntdTable, Tooltip } from "antd"

import { getLottieLoadingOptions, contentImageFormatter } from "utils/general"

import Lottie from "react-lottie"

const ConversationsContent = props => {
  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  const communityColumns = [
    /*{
      dataIndex: "vmr_number",
      title: props.t("Number"),
      width: "100px",
      ellipsis: true,
    },*/
    {
      dataIndex: "image_base64",
      title: props.t("Image"),
      align: "center",
      render: contentImageFormatter,
      width: "50px",
    },
    {
      dataIndex: "vmr_name",
      title: props.t("Name"),
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "opens_at",
      title: props.t("Opens at"),
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "closes_at",
      title: props.t("Closes at"),
      width: "100px",
      ellipsis: true,
    },
    /*{
      dataIndex: "image",
      title: props.t("Image"),
      width: "100px",
      ellipsis: true,
    },*/
    {
      dataIndex: "actions",
      title: props.t("Actions"),
      align: "center",
      render: conversationsEditFormatter,
      //fixed: "right",
      width: "100px",
      ellipsis: true,
    },
  ]

  function conversationsEditFormatter(cell, row) {
    return (
      <>
        <Tooltip
          title={props.t("Edit")}
          placement="bottom"
          trigger={["hover", "focus"]}
        >
          <Button
            color="primary"
            outline
            size="sm"
            onClick={() => {
              let entry = new Object()
              entry.id = row.vmr_id
              entry.type = row.vmr_type
              entry.name = row.vmr_name
              entry.requiresHost = row.require_host == "1"
              entry.opensAt = row.opens_at
              entry.closesAt = row.closes_at
              entry.imageBase64 = row.image_base64

              props.setSelectedRoom(entry)
              props.setVirtualRoomsModal(true)
            }}
          >
            <i className="mdi mdi-pencil" />
          </Button>
        </Tooltip>
        <Tooltip
          title={props.t("Delete")}
          placement="bottom"
          trigger={["hover", "focus"]}
        >
          <Button
            className="ms-2"
            color="danger"
            outline
            size="sm"
            onClick={() => {
              props.setSelectedRoomId(row.vmr_id)
              props.setDeleteRoomModal(true)
            }}
          >
            <i className="mdi mdi-delete" />
          </Button>
        </Tooltip>
      </>
    )
  }

  return (
    <>
      {/* ACCORDION */}
      {props.loadingConversations ? (
        <>
          <div className="text-center">
            <Lottie
              options={getLottieLoadingOptions()}
              height={80}
              width={80}
            />
          </div>
        </>
      ) : (
        <>
          <Row>
            <Col></Col>
            <Col className="col-auto">
              <Button
                color="success"
                size="sm"
                className="d-flex"
                style={{ alignItems: "center" }}
                onClick={() => {
                  props.setNewRoom(2)
                }}
              >
                <i className="me-2 bx bx-calendar-plus text-truncate align-middle"></i>
                <span className="">{props.t("New room")}</span>
              </Button>
            </Col>
          </Row>
          <Row className="mt-2 mb-3">
            <Col>
              <AntdTable
                className="clear-header"
                size="small"
                sticky
                rowKey={"vmr_id"}
                columns={communityColumns}
                dataSource={props.conversations}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: 50,
                  hideOnSinglePage: true,
                }}
                tableLayout="auto"
                scroll={{
                  x: "max-content",
                  y: "35vh",
                }}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

ConversationsContent.propTypes = {
  t: PropTypes.any,
  loadingConversations: PropTypes.any,
  conversations: PropTypes.any,
  setNewRoom: PropTypes.func,
  setSelectedRoom: PropTypes.func,
  setVirtualRoomsModal: PropTypes.func,
  setSelectedRoomId: PropTypes.func,
  setDeleteRoomModal: PropTypes.func,
}

export default withTranslation()(ConversationsContent)
